export default __webpack_public_path__ + "static/media/whatsApp.3d13a7f1.png";